"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import {
  AutomationSection,
  deriveChecks,
  markAllOverridden
} from "./pod_checks";
import { ManualPODMarkReasonCode } from "../data/types/Pb";
import { shouldShowAutomationSectionToCurrentUser } from "./pod_modal_logic";
export class PodCheckReasonContent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "toggleCode", (code) => {
      this.setState((prev) => {
        const next = new Set(prev.checkedCodes);
        if (next.has(code)) {
          next.delete(code);
        } else {
          next.add(code);
        }
        return { checkedCodes: next, otherText: prev.otherText };
      });
    });
    __publicField(this, "handleOtherTextChange", (e) => {
      const value = e.currentTarget.value;
      this.setState((prev) => {
        const next = new Set(prev.checkedCodes);
        if (value.length > 0) {
          next.add(ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther);
        }
        return { otherText: value, checkedCodes: next };
      });
    });
    __publicField(this, "handleSubmit", () => {
      this.props.onSubmit(
        Array.from(this.state.checkedCodes),
        this.state.otherText.trim()
      );
    });
    this.state = {
      checkedCodes: /* @__PURE__ */ new Set(),
      otherText: ""
    };
  }
  getPopupStyle() {
    const { anchorRect } = this.props;
    if (anchorRect) {
      return {
        top: `${anchorRect.top}px`,
        left: `${anchorRect.right + 8}px`
      };
    }
    return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  }
  failedChecks() {
    return this.props.checks.filter((c) => c.indicator === "fail");
  }
  canSubmit() {
    const { checkedCodes, otherText } = this.state;
    const failed = this.failedChecks();
    if (checkedCodes.has(ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther) && otherText.trim().length > 0)
      return true;
    if (checkedCodes.has(ManualPODMarkReasonCode.ManualPODMarkReasonCodeIllegible))
      return true;
    if (failed.length === 0) return false;
    if (this.props.isManagedIndexer) {
      return failed.every((c) => checkedCodes.has(c.code));
    }
    return failed.some((c) => checkedCodes.has(c.code));
  }
  render() {
    const failed = this.failedChecks();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "document-browser__pod-reason-popup",
        style: this.getPopupStyle()
      },
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "document-browser__pod-reason-close",
          onClick: this.props.onClose,
          "aria-label": "Close"
        },
        /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 10 10" }, /* @__PURE__ */ React.createElement(
          "path",
          {
            d: "M9 1L1 9M1 1L9 9",
            stroke: "#374151",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
          }
        ))
      ),
      this.props.showAutomationSection && /* @__PURE__ */ React.createElement(AutomationSection, { checks: this.props.checks }),
      /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-reason-section" }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-reason-title" }, "Why is this document a POD for this load?"), /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-reason-checkboxes" }, failed.map(({ code, label }) => /* @__PURE__ */ React.createElement(
        "label",
        {
          key: code,
          className: "document-browser__pod-reason-checkbox-row"
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            checked: this.state.checkedCodes.has(code),
            onChange: () => this.toggleCode(code)
          }
        ),
        /* @__PURE__ */ React.createElement("span", null, label)
      )), /* @__PURE__ */ React.createElement("label", { className: "document-browser__pod-reason-checkbox-row" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: this.state.checkedCodes.has(
            ManualPODMarkReasonCode.ManualPODMarkReasonCodeIllegible
          ),
          onChange: () => this.toggleCode(
            ManualPODMarkReasonCode.ManualPODMarkReasonCodeIllegible
          )
        }
      ), /* @__PURE__ */ React.createElement("span", null, "Legible")), /* @__PURE__ */ React.createElement("label", { className: "document-browser__pod-reason-checkbox-row" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: this.state.checkedCodes.has(
            ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther
          ),
          onChange: () => this.toggleCode(
            ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther
          )
        }
      ), /* @__PURE__ */ React.createElement("span", null, "Other")), this.state.checkedCodes.has(
        ManualPODMarkReasonCode.ManualPODMarkReasonCodeOther
      ) && /* @__PURE__ */ React.createElement(
        "textarea",
        {
          className: "document-browser__pod-reason-other-input",
          rows: 3,
          value: this.state.otherText,
          onChange: this.handleOtherTextChange,
          placeholder: "Tell us why..."
        }
      ))),
      /* @__PURE__ */ React.createElement("div", { className: "document-browser__pod-reason-submit" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "v3__button-tertiary v3__button-small",
          disabled: !this.canSubmit(),
          onClick: this.handleSubmit
        },
        "Submit"
      ))
    );
  }
}
class PodCheckReasonModal extends React.Component {
  render() {
    const derived = deriveChecks(
      this.props.document,
      this.props.accountSettings,
      this.props.hasReferenceMatch,
      this.props.matchedReferenceValues,
      this.props.loadReferences
    );
    const checks = this.props.wasManuallyMarked ? markAllOverridden(derived) : derived;
    return /* @__PURE__ */ React.createElement(
      PodCheckReasonContent,
      {
        checks,
        onClose: this.props.onClose,
        onSubmit: this.props.onSubmit,
        anchorRect: this.props.anchorRect,
        showAutomationSection: shouldShowAutomationSectionToCurrentUser(),
        isManagedIndexer: true
      }
    );
  }
}
export default PodCheckReasonModal;
